import React from "react"
import { HomeBigTeasersContainer } from "./style"
import { BigTeaser } from "components/BigTeaser"
import theme from "utils/theme.js"
import { ThemeProvider } from "styled-components"
import { useStaticQuery, graphql } from "gatsby"

const HomeBigTeasers = ({ homeData, preview }) => {
  const data = preview?.subsiteTeasers?.nodes || homeData

  console.log(preview)
  return (
    <HomeBigTeasersContainer>
      {data.map((teaser, index) => {

        if(teaser.featuredImage) {
          teaser.featuredImage.sizes="(min-width: 1024px) 1024px, 100vw";
        }
        
        return (
          <ThemeProvider key={index} theme={{ ...theme, site: teaser.slug }}>
            <BigTeaser
              index={index}
              title={teaser.header.customTitle}
              excerpt={teaser.excerpt}
              tag={teaser.slug}
              link={teaser.subsiteSettings.external.isActive
                  ? teaser.subsiteSettings.external.url
                  : teaser.link}
              label="Read more"
              img={teaser.featuredImage}
            />
          </ThemeProvider>
        )
      })}
    </HomeBigTeasersContainer>
  )
}

export default HomeBigTeasers
